var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:email-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 2H2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H16C16.2652 15 16.5196 14.8946 16.7071 14.7071C16.8946 14.5196 17 14.2652 17 14V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2ZM15.23 14H2.83L5.98195 10.74C6.17413 10.5412 6.16866 10.2243 5.96974 10.0322C5.77102 9.84043 5.45446 9.84592 5.26252 10.0445L2 13.42V3.76L8.215 9.945C8.40236 10.1313 8.65581 10.2358 8.92 10.2358C9.18419 10.2358 9.43764 10.1313 9.625 9.945L16 3.605V13.355L12.6726 10.0276C12.4779 9.83288 12.1621 9.83287 11.9674 10.0276C11.7727 10.2223 11.7726 10.5378 11.9671 10.7326L15.23 14ZM2.655 3H15.19L8.92 9.235L2.655 3Z",
    fill: "#676D7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e87b550b5bdc1664b016d2278c14c57f.svg";
export { ForwardRef as ReactComponent };